import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { Button } from '../ui/button';

interface TokenAlertProps {
  expiredStores: { name: string }[];
  zeroPriceCount: number;
  refreshing: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
}

export function TokenAlert({ expiredStores, zeroPriceCount, refreshing, onRefresh, onDismiss }: TokenAlertProps) {
  return (
    <div className="mx-4 mt-3 flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 dark:border-amber-800 dark:bg-amber-950/30">
      {/* Icon */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/50">
        <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
      </div>

      {/* Body */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-800 dark:text-amber-300">
          Payout data may be inaccurate —{' '}
          {expiredStores.length} store token{expiredStores.length > 1 ? 's' : ''} expired
        </p>
        <p className="mt-0.5 text-xs text-amber-700 dark:text-amber-400">
          Affected: {expiredStores.map(s => s.name).join(', ')}
          {zeroPriceCount > 0 && (
            <span className="ml-1 font-semibold text-red-600 dark:text-red-400">
              · {zeroPriceCount} order{zeroPriceCount > 1 ? 's' : ''} stored with 0 MAD payout
            </span>
          )}
        </p>
      </div>

      {/* Actions */}
      <div className="flex shrink-0 items-center gap-2">
        <Button
          size="sm"
          className="h-7 gap-1.5 bg-amber-600 text-white hover:bg-amber-700 text-xs"
          onClick={onRefresh}
          disabled={refreshing}
        >
          <RefreshCw className={`h-3 w-3 ${refreshing ? 'animate-spin' : ''}`} />
          {refreshing ? 'Refreshing…' : 'Refresh tokens'}
        </Button>
        <button
          onClick={onDismiss}
          className="flex h-7 w-7 items-center justify-center rounded-md text-amber-600 hover:bg-amber-100 dark:hover:bg-amber-900/50 transition-colors"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
